import type { PropType } from 'vue'
import { computed } from 'vue'

import type { Colors } from '@ui/KcalmarIcon'
import { KcalmarIcon } from '@ui/KcalmarIcon'

import { variants } from '@/utils/variants'

import type { VariantPropsOf } from '@/utils/variants'

import s from './style.module.scss'

const styles = variants({
  base: s.root,
  defaultVariants: {
    size: 'default',
    variant: 'primary',
  },
  variants: {
    disabled: {
      true: s.disabled,
    },
    size: {
      default: s['size--default'],
      large: s['size--large'],
      small: s['size--small'],
      xl: s['size--xl'],
      xs: s['size--xsmall'],
    },
    variant: {
      destructive: s['type--destructive'],
      ghost: s['type--ghost'],
      primary: s['type--primary'],
      secondary: s['type--secondary'],
      transparent: s['type--transparent'],
    },
  },
})

type Props = VariantPropsOf<typeof styles> & {
  iconClass?: string
  iconColor?: Colors
  iconSize?: IconSize
  name: RemixIconName
}

const IconSize: Record<NonNullable<VariantPropsOf<typeof styles>['size']>, IconSize> = {
  default: '24',
  large: '28',
  small: '20',
  xl: '32',
  xs: '16',
}

export const KcalmarIconButton = (props: Props) => {
  const classes = computed(() => {
    return styles({
      disabled: props.disabled,
      size: props.size,
      variant: props.variant,
    })
  })
  const iconSize = props.iconSize ?? IconSize[props.size ?? 'default']

  return (
    <button class={classes.value} disabled={props.disabled}>
      <KcalmarIcon
        class={props.iconClass}
        color={props.iconColor}
        name={props.name}
        size={iconSize}
      />
    </button>
  )
}

KcalmarIconButton.props = {
  disabled: Boolean,
  iconClass: String as PropType<Props['iconClass']>,
  iconColor: String as PropType<Colors>,
  iconSize: String as PropType<Props['iconSize']>,
  name: String as PropType<Props['name']>,
  size: String as PropType<Props['size']>,
  variant: String as PropType<Props['variant']>,
}
